import {createSlice} from "@reduxjs/toolkit"

const initialState = {
}

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    fetch: (state, action) => {

    },
  },
})

const reportsReducer = reportsSlice.reducer

export {reportsSlice, reportsReducer}
